// Non-TH doesn't display an error
// eslint-disable-next-line
export const getBillingCountryError = () => '';
